import { render, staticRenderFns } from "./PromoteModal.vue?vue&type=template&id=70f5ed33&scoped=true"
import script from "./PromoteModal.vue?vue&type=script&lang=js"
export * from "./PromoteModal.vue?vue&type=script&lang=js"
import style0 from "./PromoteModal.vue?vue&type=style&index=0&id=70f5ed33&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5ed33",
  null
  
)

export default component.exports